<!--  -->
<template>
  <div>
    <div style="margin-bottom:10px">
      <el-input v-model="pageIfon.name" style="width:200px;margin-right:10px" placeholder="请输入姓名" />
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" @click="reset">重置</el-button>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        :selectable="selectable"
      />
      <el-table-column
        prop="userNum"
        label="头像"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <img :src="scope.row.avatar" class="avatar_box" alt="">
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名字"
        align="center"
      />
    </el-table>
    <div class="pull_box">
      <el-button type="primary" style="margin-top:10px" @click="pullclick">确定</el-button>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { canaddmembers, addmembers } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10,
        name: null
      },
      tableData: [],
      multipleSelection: [],
      total: null,
      items: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      console.log('item', item)
      this.items = item
      this.candlist()
    },
    async candlist() {
      const data = await canaddmembers({ ...this.pageIfon, chatKeyId: this.items.id })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.candlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.candlist()
    },
    handleSelectionChange(val) {
      const allselect = val.map(re => re.openId)
      this.multipleSelection = allselect
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.canChose != 0 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    pullclick() {
      // eslint-disable-next-line eqeqeq
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择拉取成员')
        return
      }
      addmembers({
        chatId: this.items.chatId,
        idList: this.multipleSelection
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '拉取成功'
        })
        this.$emit('pullupdata')
      })
    },
    search() {
      this.pageIfon.page = 1
      this.candlist()
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.name = null
      this.candlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.avatar_box{
  width: 50px;
  height: 50px;
}
.pull_box{
  text-align: right;
}
</style>
